export const PDP_ADD_TO_CART = 'addToCart'
export const PDP_ATC_CLICKED = 'atcClicked'
export const PLA_POPOVER_SESSION_STORAGE = 'pla_popover_session_storage'
